// Dictionary file metadata is safe to import from settings and menus without
// loading word lists or constructing a game's dictionary and anagram indexes.
export const dictionaryLanguages: Record<string, string> = {
    english: 'scrabble-count.txt',
    danish: 'lang/danish-count.txt',
    finnish: 'lang/finnish-count.txt',
    portuguese: 'lang/portuguese-count.txt',
    german: 'lang/german-count.txt',
}

// An edition change must not hydrate a previous edition before refreshing.
export const dictionaryRevisions: Record<string, string> = { english: 'NWL2023' }
